import { render, staticRenderFns } from "./PhysicalExamForm.vue?vue&type=template&id=61c8b58b&scoped=true"
import script from "./PhysicalExamForm.vue?vue&type=script&lang=js"
export * from "./PhysicalExamForm.vue?vue&type=script&lang=js"
import style0 from "./PhysicalExamForm.vue?vue&type=style&index=0&id=61c8b58b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c8b58b",
  null
  
)

export default component.exports